// src/components/Layout/Layout.js
import React from "react";
import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <main className={`${isHome ? "pt-0" : "pt-16"} flex-grow`}>
      {children}
    </main>
  );
};

export default Layout;
